import i18n from '../../../locales';
import store from '../../../store';
import planificationEscl from '../../../locales/es-CL/planification.json';
import planificationEsmx from '../../../locales/es-MX/planification.json';
import planificationEsco from '../../../locales/es-CO/planification.json';
import planificationEnus from '../../../locales/en-US/planification.json';
import BuscadorDirecciones from '@/components/global/buscador-direcciones/buscador-direcciones.vue';
import showAlert from '../../../alert/alertHandler';
import RouteDetailMap from '../../../components/RouteDetailMap.vue';
import LogService from '../../../services/LogService';

import Container from 'typedi';
import axios from 'axios';

export default {
  name: 'OperationDetailModal',
  components: {
    BuscadorDirecciones,
    RouteDetailMap,
  },
  props: ['detailData', 'operation', 'operationList', 'spotList', 'distanceMatrixManual', 'callback'],
  data() {
    return {
      gapi: null,
      mode: null,
      viewMode: false,
      itemNames: [],
      tags: [],
      senderList: [],
      planificationId: null,
      isUpdateSpotReady: false,
      isPreOperationReady: false,
      logService: null,
      formOperationEditSpot: {
        addressComplement: null,
        neighborhood: null,
        name: null,
        address: null,
        lat: null,
        lon: null,
        idSpotTemporal: null,
        sender: null,
        documents: [],
      },
      formOperationEdit: {
        idOperationJob: null,
        name: null,
        address: null,
        addressComplement: null,
        neighborhood: null,
        lat: null,
        lon: null,
        startHour: null,
        endHour: null,
        spotServiceTime: null,
        contact: null,
        phone: null,
        email: null,
        volume: null,
        weight: null,
        money: null,
        typeOperation: {
          type: 'DELIVERY',
          name: 'Entrega',
        },
        priority: null,
        idSpotTemporal: null,
        tags: null,
        sender: null,
        documents: [],
        additionalInfo: null,
      },
      operationTypeList: [
        {
          type: 'DELIVERY',
          name: 'Entrega',
        },
        {
          type: 'COLLECTION',
          name: 'Retiro',
        },
      ],
      maxCharacterLength: 3000,
      showAdditionalInfoCounter: false,
    };
  },
  async created() {
    this.logService = Container.get(LogService);
    if (this.detailData != null) {
      this.gapi = this.detailData.gapi;
      this.mode = this.detailData.mode;
      //Si accedo en modo view entonces dejo como true la variable global
      if (this.mode === 'view') this.viewMode = true;
      this.itemNames = this.detailData.itemNames;
      this.tags = this.detailData.tags;
      this.senderList = this.detailData.senderList;
      this.planificationId = this.detailData.planificationId;
    }
    this.formOperationEdit = JSON.parse(JSON.stringify(this.operation));
    this.formOperationEditSpot.streetNameSimple = this.formOperationEdit.address;
    this.formOperationEditSpot.addressComplement = this.formOperationEdit.addressComplement;
    this.formOperationEditSpot.neighborhood = this.formOperationEdit.neighborhood;
    this.formOperationEditSpot.city = this.formOperationEdit.city;
    this.formOperationEditSpot.state = this.formOperationEdit.state;
    this.formOperationEditSpot.country = this.formOperationEdit.country;
    this.formOperationEditSpot.sender = this.formOperationEdit.sender ? this.formOperationEdit.sender : null;
    this.formOperationEditSpot.lat = this.formOperationEdit.lat;
    this.formOperationEditSpot.lon = this.formOperationEdit.lon;
    this.formOperationEditSpot.documents =
      this.formOperationEdit.documents != undefined && this.formOperationEdit.documents != null
        ? this.formOperationEdit.documents
        : [];
  },
  async mounted() {
    this.$root.$on('bv::modal::hide', () => {
      setTimeout(() => {
        this.$destroy(); // cleanup in component
        this.$el.remove();
      }, 300);
    });
    i18n.setLocaleMessage('es-CL', {
      ...i18n.messages['es-CL'],
      planification: planificationEscl,
    });

    i18n.setLocaleMessage('es-MX', {
      ...i18n.messages['es-MX'],
      planification: planificationEsmx,
    });

    i18n.setLocaleMessage('es-CO', {
      ...i18n.messages['es-CO'],
      planification: planificationEsco,
    });

    i18n.setLocaleMessage('en-US', {
      ...i18n.messages['en-US'],
      planification: planificationEnus,
    });
    const destinationPoint = {
      description: this.formOperationEdit.address,
      typeName: this.t('planification.planificationBuilder.operation.destination'),
      type: 'destination',
      coordinates: {
        lat: this.getCoordinate(this.formOperationEdit.lat),
        lng: this.getCoordinate(this.formOperationEdit.lon),
      },
    };
    await this.waitForElm('#map');
    await this.$refs.map.setMultipleMarkersClean(this.gapi, destinationPoint);
    await this.$refs.map.setZoomMap(17);
  },
  methods: {
    //Asegura que el dato que venga sea de tipo float, y no algo diferente
    getCoordinate(value) {
      let coordinate = parseFloat(value);
      return isNaN(coordinate) ? null : coordinate;
    },
    /**@author Jorge Pizarro Tapia
     * Metodo que permite interactuar con los .json de las traducciones.
     * @param {String} key, es el elemento del .json a utilizar.
     * @param {String} value, es la variable a insertar (en caso de que el elemento lo solicite).
     * @returns el resultado de la traduccion.
     */
    t(key, value) {
      return i18n.t(key, value);
    },
    async waitForElm(selector) {
      return new Promise((resolve) => {
        if (document.querySelector(selector)) {
          return resolve(document.querySelector(selector));
        }

        const observer = new MutationObserver(() => {
          if (document.querySelector(selector)) {
            resolve(document.querySelector(selector));
            observer.disconnect();
          }
        });

        observer.observe(document.body, {
          childList: true,
          subtree: true,
        });
      });
    },
    async updateOperation() {
      if (this.validateUpdateOp() && this.checkCustomerEmails()) {
        let opToUpdate = this.operationList.find((op) => op.idOperationJob === this.formOperationEdit.idOperationJob);

        if (opToUpdate.idOperationJob === this.formOperationEdit.idOperationJob) {
          //Este proceso es para evitar la actualización de la operación si es que fue gestionada
          if (this.planificationId) {
            const opsWStatus = await this.getOperationsWithStatus([opToUpdate.uuid]);
            if (opsWStatus && opsWStatus.length > 0 && opsWStatus[0].state !== 'NOTHANDLED') {
              //Como voy a actualizar unicamente el estado de la operación debo enviar la operación previa a todos los cambios realizados en el modal
              const updateOnlyStatus = JSON.parse(JSON.stringify(this.operation));
              updateOnlyStatus.operationState = opsWStatus[0].state;
              this.callback(updateOnlyStatus, 'update');
              showAlert(
                this.t('common.modals.warning'),
                this.t('planification.planificationBuilder.operation.invalidActionEdit'),
                'success',
              );
              this.closeModal('operation-detail-modal');
              return;
            }
          }
          if (
            opToUpdate.address != this.formOperationEditSpot.streetNameSimple ||
            opToUpdate.city != this.formOperationEditSpot.city ||
            opToUpdate.state != this.formOperationEditSpot.state ||
            opToUpdate.country != this.formOperationEditSpot.country ||
            opToUpdate.addressComplement != this.formOperationEditSpot.addressComplement ||
            opToUpdate.neighborhood != this.formOperationEditSpot.neighborhood ||
            opToUpdate.lat != this.formOperationEditSpot.lat ||
            opToUpdate.lon != this.formOperationEditSpot.lon
          ) {
            const updateCoordinates =
              opToUpdate.lat != this.formOperationEditSpot.lat || opToUpdate.lon != this.formOperationEditSpot.lon;
            this.isUpdateSpotReady = true;
            await this.updateSpotTemporal(updateCoordinates);
          }
          this.formOperationEdit.address = this.formOperationEditSpot.streetNameSimple;
          this.formOperationEdit.addressComplement = this.formOperationEditSpot.addressComplement;
          this.formOperationEdit.neighborhood = this.formOperationEditSpot.neighborhood;
          this.formOperationEdit.city = this.formOperationEditSpot.city;
          this.formOperationEdit.state = this.formOperationEditSpot.state;
          this.formOperationEdit.country = this.formOperationEditSpot.country;
          this.formOperationEdit.lat = this.formOperationEditSpot.lat;
          this.formOperationEdit.lon = this.formOperationEditSpot.lon;
          opToUpdate = this.formOperationEdit;
          this.callback(opToUpdate, 'update');
        }
        this.isUpdateSpotReady = false;
        showAlert(
          this.t('common.modals.exitoTitulo'),
          this.t('planification.planificationBuilder.operation.modalUpdate'),
          'success',
        );
        this.closeModal('operation-detail-modal');
      }
      this.isManualMapActive = true;
    },

    async closeOperationView() {
      this.closeModal('operation-detail-modal');
    },

    async getOperationsWithStatus(listOpUuid) {
      const urlPlanification = `${store.getters.urlAPI}/operation/byPlanification/${this.planificationId}`;
      try {
        this.logService.sendInfo({
          component: 'operationProcess',
          message: `getOperationsWithStatus voy a buscar las operaciones con la url ${urlPlanification}`,
        });
        const config = {
          headers: {
            'id-client': store.getters.clientId,
            Authorization: `Bearer ${store.getters.accessToken}`,
          },
        };
        const response = await axios.post(urlPlanification, listOpUuid, config);
        return response.data.data.map((op) => {
          return {
            ...op,
            state: op.state === 'NEW' ? 'NOTHANDLED' : op.state,
          };
        });
      } catch (e) {
        this.logService.sendError({
          component: 'operationProcess',
          message: `getOperationsWithStatus fallo ${e.message}`,
        });
        console.log(e);
        return [];
      }
    },
    goBack() {
      this.closeModal('operation-detail-modal');
    },
    //No se usa este metodo
    async closeAllModal() {
      //Esto llamara al callback de addOperations el cual llamara a su callback indicando que debe cerrar su modal
      await this.callback(null, 'close');
      this.closeModal('operation-detail-modal');
    },
    async preLoadOperation() {
      if (this.validateOperationType() && this.validateAdditionalInfo()) {
        this.isPreOperationReady = true;
        this.formOperationEdit.address = this.formOperationEditSpot.streetNameSimple;
        this.formOperationEdit.addressComplement = this.formOperationEditSpot.addressComplement;
        this.formOperationEdit.neighborhood = this.formOperationEditSpot.neighborhood;
        this.formOperationEdit.city = this.formOperationEditSpot.city;
        this.formOperationEdit.state = this.formOperationEditSpot.state;
        this.formOperationEdit.country = this.formOperationEditSpot.country;
        this.formOperationEdit.lat = this.formOperationEditSpot.lat;
        this.formOperationEdit.lon = this.formOperationEditSpot.lon;

        await this.callback(this.formOperationEdit, 'update');
        this.isPreOperationReady = false;
        this.closeModal('operation-detail-modal');
      }
    },
    /**
     * Este metodo actualiza el spot de una operacion pero insertando un nuevo spot
     * @returns
     */
    async updateSpotTemporal(haveCoordinates) {
      try {
        const body = {
          addressComplement: this.formOperationEditSpot.addressComplement,
          address: this.formOperationEditSpot.streetNameSimple,
          city: this.formOperationEditSpot.city,
          state: this.formOperationEditSpot.state,
          country: this.formOperationEditSpot.country.normalize('NFD').replace(/[\u0300-\u036f]/g, ''),
          neighborhood: this.formOperationEditSpot.neighborhood,
        };
        if (haveCoordinates) {
          body.lat = this.formOperationEditSpot.lat;
          body.lon = this.formOperationEditSpot.lon;
        }
        const response = await axios.post(`${store.getters.urlAPI}/spot/createTemporal`, body, {
          headers: {
            'id-client': store.getters.clientId,
            Authorization: `Bearer ${store.getters.accessToken}`,
          },
        });
        const ret = response.data.data;
        this.deleteSpotWithIdOperation(this.formOperationEdit);
        //Actualizo la infomración del id del spot temporal por el nuevo obtenido
        this.formOperationEdit.idSpotTemporal = ret.id;
        this.formOperationEdit.geocodingResult = ret.geocodingResult;
        //Se añade el nuevo spot al listado
        this.spotList.push(ret);
        if (this.planificationId) {
          //Si estoy editando una planificacion, entonces el nuevo spot se añade a los origenes del distanceMatrix
          this.distanceMatrixManual.origins.push({
            name: ret.id,
            lat: ret.address.lat,
            lon: ret.address.lon,
          });
        }
        return ret;
      } catch (e) {
        this.isUpdateSpotReady = false;
        console.log(e);
        return null;
      }
    },
    /**
     * Metodo que elimina del listado de spots unicamente si pertenece a una sola operación
     * @param {Operation} selectedOperation
     */
    deleteSpotWithIdOperation(selectedOperation) {
      //Busco si es que hay mas operaciones con el mismo id de spot
      const multipleSameSpots = this.operationList.filter((operation) => {
        if (selectedOperation.idSpotTemporal === operation.idSpotTemporal) {
          return operation;
        }
      });
      //Si solamente existe una operacion con ese spot, entonces busco el spot dentro del listado para eliminarlo
      if (multipleSameSpots && multipleSameSpots.length < 2) {
        const indice = this.spotList.findIndex((spot) => spot.id === selectedOperation.idSpotTemporal);
        if (indice >= 0) {
          this.spotList.splice(indice, 1);
        }
      }
    },

    async receiveAddressInformationEditSpot(addressInfo) {
      if (addressInfo.streetName !== '') {
        this.formOperationEditSpot.addressComplement = addressInfo.addressComplement;
        this.formOperationEditSpot.neighborhood = addressInfo.neighborhood;
        this.formOperationEditSpot.addressExtra = `${addressInfo.city} ${addressInfo.state}`;
        this.formOperationEditSpot.address =
          addressInfo.number !== undefined
            ? addressInfo.streetName + ' ' + addressInfo.number + ' ' + this.formOperationEditSpot.addressExtra
            : addressInfo.streetName + ' ' + this.formOperationEditSpot.addressExtra;
        this.formOperationEditSpot.lat = addressInfo.coordinates.lat;
        this.formOperationEditSpot.lon = addressInfo.coordinates.lng;
        this.formOperationEditSpot.city = addressInfo.city;
        this.formOperationEditSpot.state = addressInfo.state;
        this.formOperationEditSpot.country = addressInfo.country;
        this.formOperationEditSpot.streetNameSimple =
          addressInfo.number !== undefined ? `${addressInfo.streetName} ${addressInfo.number}` : addressInfo.streetName;

        const destinationPoint = {
          description: this.formOperationEditSpot.address,
          typeName: this.t('planification.planificationBuilder.operation.destination'),
          type: 'destination',
          coordinates: {
            lat: this.formOperationEditSpot.lat,
            lng: this.formOperationEditSpot.lon,
          },
        };
        console.log('Datos a enviar ', destinationPoint);
        await this.waitForElm('#map');
        await this.$refs.map.setMultipleMarkersClean(this.gapi, destinationPoint);
      }
    },
    addDocument() {
      if (this.formOperationEdit.documents == null) {
        this.formOperationEdit.documents = [];
      }
      this.formOperationEdit.documents.push({
        name: null,
        description: null,
        observation: null,
        type: 33, //!ESTO NO SE QUE ES(PREGUNTAR A DANIEL)
        number: null,
        items: [],
      });
      this.refresh();
    },
    addItem(index) {
      if (this.formOperationEdit.documents[index].items == null) {
        this.formOperationEdit.documents[index].items = [];
      }
      this.formOperationEdit.documents[index].items.push({
        itemSelected: null,
        quantity: null,
        unitPrice: null,
      });
      this.refresh();
    },
    refresh() {
      this.$forceUpdate();
    },
    onSelectItem(documentIndex, itemIndex) {
      console.log('this.formOperationEdit.documents[documentIndex].items[itemIndex]');
      console.log(this.formOperationEdit.documents[documentIndex].items[itemIndex]);
      this.formOperationEdit.documents[documentIndex].items[itemIndex].name =
        this.formOperationEdit.documents[documentIndex].items[itemIndex].itemSelected.name;
      this.formOperationEdit.documents[documentIndex].items[itemIndex].idItem =
        this.formOperationEdit.documents[documentIndex].items[itemIndex].itemSelected.idItem;
      this.formOperationEdit.documents[documentIndex].items[itemIndex].idItemData =
        this.formOperationEdit.documents[documentIndex].items[itemIndex].itemSelected.id;
      this.formOperationEdit.documents[documentIndex].items[itemIndex].code =
        this.formOperationEdit.documents[documentIndex].items[itemIndex].itemSelected.code;
      this.formOperationEdit.documents[documentIndex].items[itemIndex].description =
        this.formOperationEdit.documents[documentIndex].items[itemIndex].itemSelected.description;

      this.formOperationEdit.documents[documentIndex].items[itemIndex].extra1 =
        this.formOperationEdit.documents[documentIndex].items[itemIndex].itemSelected.extra1;
      this.formOperationEdit.documents[documentIndex].items[itemIndex].extra2 =
        this.formOperationEdit.documents[documentIndex].items[itemIndex].itemSelected.extra2;
      this.formOperationEdit.documents[documentIndex].items[itemIndex].extra3 =
        this.formOperationEdit.documents[documentIndex].items[itemIndex].itemSelected.extra3;
      this.formOperationEdit.documents[documentIndex].items[itemIndex].extra4 =
        this.formOperationEdit.documents[documentIndex].items[itemIndex].itemSelected.extra4;
      this.formOperationEdit.documents[documentIndex].items[itemIndex].extra5 =
        this.formOperationEdit.documents[documentIndex].items[itemIndex].itemSelected.extra5;
      this.formOperationEdit.documents[documentIndex].items[itemIndex].additionalInfo =
        this.formOperationEdit.documents[documentIndex].items[itemIndex].itemSelected.additionalInfo;
      this.refresh();
    },
    checkCustomerEmails() {
      if (this.formOperationEdit.email) {
        let emails = [];
        const listEmails = this.formOperationEdit.email.split(/[,;]/);
        let validEmails = true;
        listEmails.forEach((email) => {
          if (validEmails) {
            email = email.trim();
            validEmails = this.isEmailValid(email);
          }
          emails.push(email);
        });
        this.formOperationEdit.email = emails.join(',');
        if (validEmails) {
          return true;
        } else {
          this.showPopover('customerEmail');
          return false;
        }
      }
      return true;
    },
    isEmailValid(email) {
      const re = /^[a-zA-Z0-9.ñ_%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      return re.test(email.trim());
    },
    validateUpdateOp() {
      let operationType = this.validateOperationType();
      let street = this.validateStreet();
      let city = this.validateCity();
      let state = this.validateStateAddress();
      let country = this.validateCountry();
      let document = this.validateDocuments();
      let items = this.validateItems();
      let additionalInfoLength = this.validateAdditionalInfo();
      return street && city && state && country && document && items && operationType && additionalInfoLength;
    },
    validateDocuments() {
      let isValid = true;
      if (this.formOperationEdit.documents == undefined || this.formOperationEdit.documents == null) {
        this.formOperationEdit.documents = [];
      }
      this.formOperationEdit.documents.forEach((document, index) => {
        if (isValid) {
          if (document.name == null || document.name == '') {
            isValid = false;
            this.showPopover('documentName' + index);
          }
          if ((document.number == null || document.number == '') && isValid) {
            isValid = false;
            this.showPopover('documentNumber' + index);
          }
        }
      });
      return isValid;
    },
    validateItems() {
      let isValid = true;
      for (let i = 0; i < this.formOperationEdit.documents.length; i++) {
        if (
          this.formOperationEdit.documents[i].items == undefined ||
          this.formOperationEdit.documents[i].items == null
        ) {
          this.formOperationEdit.documents[i].items = [];
        }
        for (let j = 0; j < this.formOperationEdit.documents[i].items.length; j++) {
          if (isValid) {
            if (
              this.formOperationEdit.documents[i].items[j].itemSelected == null ||
              this.formOperationEdit.documents[i].items[j].itemSelected == ''
            ) {
              isValid = false;
              this.showPopover('document' + i + 'item' + j);
            }
            if (
              (this.formOperationEdit.documents[i].items[j].quantity == null ||
                this.formOperationEdit.documents[i].items[j].quantity == '') &&
              isValid
            ) {
              isValid = false;
              this.showPopover('document' + i + 'itemQuantity' + j);
            }
          }
        }
      }
      return isValid;
    },
    validateOperationType() {
      if (this.formOperationEdit.typeOperation) {
        return true;
      }
      this.showPopover('typeOperation');
      return false;
    },
    validateAdditionalInfo() {
      if (
        !this.formOperationEdit.additionalInfo ||
        this.formOperationEdit.additionalInfo.length <= this.maxCharacterLength
      ) {
        return true;
      }
      return false;
    },
    validateStreet() {
      if (this.formOperationEditSpot.streetNameSimple) {
        return true;
      }
      this.showPopover('address');
      return false;
    },
    validateCity() {
      if (this.formOperationEditSpot.city) {
        return true;
      }
      this.showPopover('city');
      return false;
    },
    validateStateAddress() {
      if (this.formOperationEditSpot.state) {
        return true;
      }
      this.showPopover('state');
      return false;
    },
    validateCountry() {
      if (this.formOperationEditSpot.country) {
        return true;
      }
      this.showPopover('country');
      return false;
    },

    deleteDocument(index) {
      delete this.formOperationEdit.documents[index];
      this.formOperationEdit.documents = this.formOperationEdit.documents.filter((document) => document);
      this.refresh();
    },
    deleteItem(documentIndex, itemIndex) {
      delete this.formOperationEdit.documents[documentIndex].items[itemIndex];
      this.formOperationEdit.documents[documentIndex].items = this.formOperationEdit.documents[
        documentIndex
      ].items.filter((item) => item);
      this.refresh();
    },
    showPopover(id) {
      const wrongClass = 'wrong-input';
      this.$root.$emit('bv::show::popover', id);
      const multiselect = document.querySelector(`#${id} .multiselect`);
      if (multiselect) {
        multiselect.classList.add(wrongClass);
        return;
      }
      if (document.getElementById(id)) {
        document.getElementById(id).classList.add(wrongClass);
      }
    },
    hidePopover(id) {
      const wrongClass = 'wrong-input';
      this.$root.$emit('bv::hide::popover', id);
      const multiselect = document.querySelector(`#${id} .multiselect`);
      if (multiselect) {
        multiselect.classList.remove(wrongClass);
        return;
      }
    },
    closeModal(id) {
      this.$bvModal.hide(id);
    },
  },
};
